import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Button,
    Backdrop,
    IconButton,
    TextField,
    MenuItem,
    Checkbox
} from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { useSelector, useDispatch } from "react-redux";
import * as projectActions from "../../../../store/project";
import Close from "../../../../assets/close.svg";
import { useParams } from "react-router-dom";
import {optionsDocumentsType} from "../../../../utils/category";


function EditDocPopup() {
    const dispatch = useDispatch();
    let { uuid } = useParams();
    const [summary, setSummary] = useState("");
    const [documentMulti, setDocumentMulti] = useState([]);
    const [errorDocument, setErrorDocument] = useState(false);
    const project = useSelector((state) => state.project);
    const doc = useSelector((state) => state?.project?.doc);

    useEffect(() => {
      
        if (doc) {
            setSummary(doc?.title)
            setDocumentMulti([doc?.category])
        }
    }, [doc]);

    const handleClose = async () => {
        const authdata = await dispatch(projectActions.closeEditDocBackdrop());
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            ...doc,
            title: summary,
            category: documentMulti[0],
            
        }
        await dispatch(projectActions.updateDocument(data));
        const docu = await dispatch(projectActions.allDocuments(uuid));

        await dispatch(projectActions.closeEditDocBackdrop());
    }

    const handleSummaryChange = (e) => {
        setSummary(e.target.value)
    }


    const handleDocumentChange = (event) => {
        setErrorDocument(false);
        const {
            target: { value },
        } = event;
        setDocumentMulti(
            typeof value === "string" ? value.split(",") : value
        );
    };

    return (
        <Box>
            <CssBaseline />
            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    display: "flex",
                    justifyContent: "center",
                }}
                open={project?.editBackdrop}
            >
                <Box
                    sx={{
                        backgroundColor: "#fff",
                        height: "auto",
                        maxWidth: "500px",
                        width: "500px",
                        margin: "32px",
                        padding: "24px 24px",
                        overflowY: "auto",
                        borderRadius: "8px"
                    }}
                >
                    <Box>
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="h6" sx={{ color: "#12190F", fontWeight: "700", letterSpacing: "0.9px" }}>
                                Update Doc
                            </Typography>
                            <IconButton aria-label="delete" size="small" onClick={handleClose}>
                                <Box>
                                    <img src={Close} height={"24px"} alt="Close" />
                                </Box>
                            </IconButton>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            width: "100%",
                            height: "calc ( 100vh - 120px)",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <CssBaseline />
                        <Box
                            sx={{
                                display: "flex",
                                width: { xs: "100%", sm: "500px" },
                                p: 2,
                                flexDirection: "column",
                            }}
                        >
                            <Box sx={{ display: "flex", width: '100%', flexDirection: "column", gap: 1, pt: 1, pb: 1 }}>
                            <label htmlFor="industry">
                                    Document Title<span style={{ color: "red" }}>*</span>
                                </label>
                                <textarea
                                    label="About Company"
                                    value={summary}
                                    onChange={handleSummaryChange}
                                />
                            </Box>


                            <Box sx={{ pt: 3 }}>
                                <label htmlFor="industry">
                                    Document Type<span style={{ color: "red" }}>*</span>
                                </label>

                                <TextField
                                    id="outlined-select-gender"
                                    select
                                    label={
                                        !documentMulti || documentMulti?.length == 0
                                            ? "Select documents type"
                                            : ""
                                    }
                                    InputLabelProps={{ shrink: false }}
                                    SelectProps={{
                                        multiple: false,
                                        value: documentMulti,
                                        onChange: handleDocumentChange,
                                        renderValue: (selected) => selected.join(", "),
                                    }}
                                    margin="normal"
                                    variant="outlined"
                                    size="medium"
                                    value={documentMulti}
                                    onChange={handleDocumentChange}
                                    sx={{
                                        width: "100%",
                                        color: "#606060",
                                        marginTop: "8px",
                                        "& .MuiInputLabel-root": {
                                            color: "#9BA5B7 !important",
                                        },
                                    }}
                                >
                                    {optionsDocumentsType.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            <Checkbox
                                                checked={documentMulti.indexOf(option.value) > -1}
                                            />
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </TextField>

                                {errorDocument && (
                                    <span style={{ color: "#F55B64", fontSize: "14px" }}>
                                        Select an option
                                    </span>
                                )}
                            </Box>

                            <Button
                                onClick={handleSubmit}
                                fullWidth
                                variant="contained"
                                sx={{
                                    mt: 0,
                                    mb: 2,
                                    height: "52px",
                                    textTransform: "none",
                                    fontSize: "18px",
                                }}
                            >
                                Update
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Backdrop>
        </Box>
    );
}

export default EditDocPopup;